export default __webpack_public_path__ + "static/media/ic_launcher_round.64b7b106.png";